module.exports = __webpack_public_path__ + "static/media/communityIconDark.853d1a6d.png";